const isBonusEligibilitySection = (
  s: PerformanceBoardTypes.SlideOut.SlideOutSection,
): s is PerformanceBoardTypes.SlideOut.BonusEligibilitySection => {
  return s.sectionType === 'Bonus Eligibility';
};

export default isBonusEligibilitySection;
